import { container } from '@/container';
import { Logger } from '@/services/Logger';
import { TripCopyReqMsg } from '@/services/signalr/MessageTypes/TripCopy';
import { Signalr } from '@/services/signalr/Signalr';

const logger = container.get(Logger);

export interface DuplicateTripParams {
  id: string;
  context: string;
  numberOfTrips: string | number;
  withAssignment: string | boolean;
  withAttachments: string | boolean;
  unitId?: string;
}

/**
 * Duplicate a trip via SignalR.
 * @param params - The duplication parameters
 */
export async function duplicateTrip(params: DuplicateTripParams): Promise<void> {
  try {
    const signalr = await container.getAsync(Signalr);
    await signalr.invoke(TripCopyReqMsg, {
      contextKey: params.context,
      transportId: params.id,
      numberCopies: params.numberOfTrips,
      withAssignment: params.withAssignment,
      withAttachments: params.withAttachments,
      ...(params.unitId ? { unitId: params.unitId } : {}),
    });
  }
  catch (error) {
    logger.captureException(error as Error, { tags: { signalr: 'UpdateTrip' } });
    throw error;
  }
}
